import { styled } from "@mui/material";
import CollapsableFormSection from "controls/global/collapsable-form-section";
import TextInputField from "controls/global/text-input-field";
import React, { 
  useEffect,
} from "react";
import theme from "theme/default";
import { gaps } from "theme/defaultStyle";
import useFormWrapper from "utils/custom-hooks/useFormWrapper";

const Container = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: gaps.large1,
  [theme.breakpoints.down("md")]: {
    "& > *": {
      maxWidth: "100%",
    },
  },
  "& > .container-clear": {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-end",
    gap: gaps.large1,
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      width: "100%",
    },
  },
  "& > .container-row": {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: gaps.large1,
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      minWidth: "100%",
    },
  },
  [theme.breakpoints.down("md")]: {
    "& > *": {
      maxWidth: "100%",
    },
  },
"& > .firstRow": {
  display: "flex",
  flexWrap: "nowrap",
  gap: gaps.large1,
  "& > .lot": {
    flex: "1 1 15%",
  },
  "& > .block": {
    flex: "1 1 15%",
  },
  "& > .subdivision": {
    flex: "2 1 38%",
  },
  "& > .book": {
    flex: "1 1 10%",
  },
  "& > .page": {
    flex: "1 1 10%",
  },
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
  },
},
"& > .SecondRow": {
  display: "flex",
  flexWrap: "nowrap",
  gap: gaps.large1,
  "& > .secondSection": {
    flex: "1 1 31.9%",
    "@media (min-width: 1925px)": {
      flex: "1 1 32.1%",

    },
  },
  "& > .township": {
    flex: "1 1 38.5%",
    "@media (min-width: 1925px)": {
      flex: "1 1 39%",

    },
  },
  "& > .range": {
    flex: "1 1 22%",
  },
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
  },
},

  "&  .thirdRow": {
    display: "flex",
    maxWidth: "100%",
    gap: gaps.large1,
    "& > div": {
      flexBasis: "content",
      flexGrow: 1,
      flexShrink: 1,
    },
  },
  "& > .lot, & > .block, & > .subdivision, & > .book > , & > .page": {
    [theme.breakpoints.down("md")]: {
      maxWidth: "100%",
    },
  },
  
});

type Props = {
  propertyIndex: number;
  isPropertyDisabled: boolean;
  onChange?: any;
  schema?: any;
  isParentCollapsed?: boolean;
};

const AdditionalInformation = ({ propertyIndex, isPropertyDisabled, onChange, schema ,isParentCollapsed}: Props) => {
  const propertyName = `properties.${propertyIndex}`;
  const { setValue, getValues } = useFormWrapper();

  useEffect(() => {}, [getValues, setValue, propertyIndex, isPropertyDisabled]);
  if (isParentCollapsed) return null; 
  return (
    <CollapsableFormSection
      index={propertyIndex}
      title="Additional Information"
      showDelete={false}
      isExpandedParent={false}
      showDivider={false}
    >
      <Container>
        <div className="container-row firstRow">
          <div className=" container-row lot">
            <TextInputField
              className="field"
              label="Lot"
              name={`${propertyName}.lot`}
              maxLength={100}
              disabled={isPropertyDisabled}
              onChange={onChange}
            />
          </div>
          <div className=" container-row block">
            <TextInputField
              className="field"
              label="Block"
              name={`${propertyName}.block`}
              maxLength={100}
              disabled={isPropertyDisabled}
              onChange={onChange}
            />
          </div>
          <div className=" container-row subdivision">
            <TextInputField
              className="field"
              label="Subdivision"
              name={`${propertyName}.subdivision`}
              maxLength={255}
              disabled={isPropertyDisabled}
              defaultValue={getValues(`${propertyName}.subdivision`)}
              onChange={onChange}
            />
          </div>
          <div className=" container-row book">
            <TextInputField
              className="field"
              label="Book"
              name={`${propertyName}.book`}
              maxLength={100}
              disabled={isPropertyDisabled}
              onChange={onChange}
            />
          </div>
          <div className=" container-row page">
            <TextInputField
              className="field"
              label="Page"
              name={`${propertyName}.page`}
              maxLength={100}
              disabled={isPropertyDisabled}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="container-row SecondRow">
          <div className="container-row secondSection">
            <TextInputField
              className="field"
              label="Section"
              name={`${propertyName}.section`}
              maxLength={100}
              disabled={isPropertyDisabled}
              onChange={onChange}
            />
          </div>
          <div  className="container-row township">
            <TextInputField
              className="field"
              label="Township"
              name={`${propertyName}.township`}
              maxLength={100}
              disabled={isPropertyDisabled}
              onChange={onChange}
            />
          </div>
          <div className="container-row range">
            <TextInputField
              className="field"
              label="Range"
              name={`${propertyName}.range`}
              maxLength={100}
              disabled={isPropertyDisabled}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="container-row thirdRow" >   
          <TextInputField
            className="field"
            label="Property Description"
            name={`${propertyName}.metesAndBounds`}
            maxLength={2000}
            disabled={isPropertyDisabled}
            onChange={onChange}
            multiline
          />
        </div>
      </Container>
    </CollapsableFormSection>
  );
};

export default React.memo(AdditionalInformation);
